import { MULTI_ORDER_VALUE } from 'my-purchases/constants/constants'
import type { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import type { Order } from 'my-purchases/types/purchaseList'

import { getOrderStatusInfo } from './getOrderStatusInfo'

interface GetMultiOrderStatusProps {
	orders: Order[]
	isActive: boolean
	paymentMethod: PAYMENT_TYPES
}

export function getMultiOrderStatus({
	orders,
	isActive,
	paymentMethod,
}: GetMultiOrderStatusProps) {
	const firstOrder = orders[0]

	const { id: firstOrderId, alert } = firstOrder

	const normalizedOrders = orders.map((order, index) => ({
		key: `${order.id || firstOrderId}_${orders.length - index}`,
		alert: order.alert || alert,
		status: order.status,
		orderLineCount: order.orderLineCount,
		order,
	}))

	const doubleOrder = normalizedOrders.length === MULTI_ORDER_VALUE
	if (doubleOrder) {
		return normalizedOrders.map((element, index) => ({
			orderId: `${element.order.id}_${index}`,
			statusTitle: 'myPurchases.online.multiOrder.parcelNumber.title',
			statusTitlePlaceholders: {
				1: index + 1,
			},

			isAlert: !!alert,
			...(alert
				? getOrderStatusInfo({
						order: firstOrder,
						paymentMethod,
						isActive,
					})
				: {
						statusMessage: `myPurchases.online.status_${element.status}.label`,
					}),
		}))
	}

	return {
		orderId: firstOrderId,
		statusTitle: 'myPurchases.online.multiorder.text',
		statusTitlePlaceholders: {
			1: normalizedOrders.length,
		},
		statusMessage: '',
		screenReaderText: 'accessibility.myPurchases.orderStatus.text',
		isAlert: false,
	}
}
